export default function select2(select2Query) {
  return {
    restrict: 'A',
    scope: {
      config: '=',
      ngModel: '=',
      select2Model: '=',
      ngChange: '&',
      ngSelect: '=', //回传数据
    },
    link(scope, element, attrs) {
      // 初始化
      const { tagName } = element[0]
      const config = {
        allowClear: true,
        multiple: !!attrs.multiple,
        placeholder: attrs.placeholder || ' ', // 修复不出现删除按钮的情况
      }

      // 生成select
      if (tagName === 'SELECT') {
        // 初始化
        var $element = $(element)
        delete config.multiple
        angular.extend(config, scope.config)
        $element.prepend('<option value=""></option>').val('').select2(config)

        // model - view
        scope.$watch(
          'ngModel',
          (newVal) => {
            setTimeout(() => {
              $element.find('[value^="?"]').remove() // 清除错误的数据
              $element.select2('val', newVal)
            }, 0)
          },
          true
        )
        return false
      }

      // 处理input
      if (tagName === 'INPUT') {
        // 初始化
        var $element = $(element)

        // 获取内置配置
        if (attrs.query) {
          scope.config = select2Query[attrs.query]()
        }

        // 动态生成select2
        scope.$watch(
          'config',
          () => {
            angular.extend(config, scope.config)
            $element.select2('destroy').select2(config)
          },
          true
        )

        // view - model
        $element.on('change', () => {
          scope.$apply(() => {
            scope.select2Model = $element.select2('data')
            scope.ngChange(scope.select2Model)
            scope.ngSelect && scope.ngSelect(scope.select2Model)
          })
        })

        // model - view
        scope.$watch(
          'select2Model',
          (newVal) => {
            $element.select2('data', newVal)
          },
          true
        )

        // model - view
        scope.$watch(
          'ngModel',
          (newVal) => {
            // 跳过ajax方式以及多选情况
            if (config.ajax || config.multiple) {
              return false
            }
            $element.select2('val', newVal)
          },
          true
        )
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/select2/select2Directive.js